export const FIRST_VISIT_TUTORIAL_SEEN_KEY = "aurora-forecaster:first-visit-tutorial:v1";
export const FIRST_VISIT_TUTORIAL_DISMISSED_EVENT = "aurora-forecaster:first-visit-tutorial-dismissed";
